import {Dialog, Grid, IconButton, Typography} from "@mui/material";
import {PrimaryStar} from "../../../../../utils/icons";
import EnhancedImageField from "../../../../../components/EnhancedImageField";
import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import {SortableHandle} from "react-sortable-hoc";
import type {
    CatalogProduct,
    ProductAttribute,
    ProductImageMetadata,
} from "../types";

// region TypeScript Interfaces
interface DraggableProps {
    children: React.ReactNode;
    style?: React.CSSProperties;
}

export interface ProductImageProps {
    product: CatalogProduct;
    catalog?: string;
    partnerId?: string | number;
    uploadUrl: string;
    listkey: number | string;
    updateProductState: (attribute: string, value: any) => void;
    attribute: ProductAttribute;
    isPrimary: boolean;
    imageExist: boolean;
    imageMetadata?: ProductImageMetadata | false | undefined;
    label: React.ReactNode;
    width: string;
    height: string;
    disabled?: boolean;
}
// endregion

const Draggable = SortableHandle((({children, style}: DraggableProps) => (
    <div style={{cursor: "move", ...style}}>{children}</div>
)) as any);

export const ProductImage = (props: ProductImageProps) => {
    const [imageEnlarge, setImageEnlarge] = React.useState(false);

    const label = (
        <Grid item style={{
            flex: 0,
            padding: "8px",
            textAlign: "left",
            backgroundColor: "#F9F9F9",
            zIndex: 1
        }}>
            <Typography>
                {props.label}
            </Typography>
        </Grid>
    );

    return (
        <Grid item container key={props.listkey}
              style={{
                  flexDirection: "column",
                  width: props.width,
                  height: props.height,
                  flexShrink: 0,
                  border: "1px #DCDCDC",
                  borderStyle: props.imageExist ? "solid" : "dashed",
                  borderRadius: "6px",
              }}>
            {props.isPrimary ? (
                <>
                    {label}
                </>
            ) : (
                <Draggable>
                    {label}
                </Draggable>
            )}
            <Grid item container style={{
               flex: 1,
               position: "relative",
               zIndex: 0,
           }}>
               {(props.product.Attributes[props.attribute.Name] !== ""
                       && props.product.Attributes[props.attribute.Name] !== undefined
                       && props.isPrimary)
                   && (
                       <div style={{
                           position: "absolute",
                           left: "10px",
                           top: "10px",
                           zIndex: 5,
                       }}>
                           <PrimaryStar/>
                       </div>
                   )}

               <EnhancedImageField onChange={(e: any) => props.updateProductState(props.attribute.Name, e)}
                                   onSetPrimaryImage={() => {
                                       const primaryImage = props.product.Attributes[props.attribute.Name];
                                       props.updateProductState(props.attribute.Name, props.product.Attributes["image"]);
                                       props.updateProductState("image", primaryImage);
                                   }}
                                   uploadUrl={props.uploadUrl}
                                   value={props.product.Attributes[props.attribute.Name]}
                                   onClick={() => setImageEnlarge(!imageEnlarge)}
                                   imageStyles={{
                                       maxHeight: props.isPrimary ? "268px" : "92px",
                                       width: "80%",
                                       objectFit: "contain"
                                   }}
                                   disabled={props.disabled}
                                   isPrimary={props.isPrimary}
               />
           </Grid>
            {props.imageExist && (
                <Grid item container
                      justifyContent={"space-between"}
                      style={{
                          flex: 0,
                          padding: "8px",
                          background: "#F9F9F9",
                          zIndex: 1
                      }}>
                    {props.imageMetadata && (
                        <>
                            <Typography style={{fontSize: !props.isPrimary ? "10px" : "inherit"}}>
                                {props.imageMetadata.width} x {props.imageMetadata.height}px
                            </Typography>
                            <Typography style={{fontSize: !props.isPrimary ? "10px" : "inherit"}}>
                                {Math.ceil((props.imageMetadata.size ?? 0) / 1000)}kb
                            </Typography>
                        </>
                    )}
                </Grid>
            )}
            <Dialog open={imageEnlarge} onClose={() => setImageEnlarge(false)} maxWidth={"lg"} fullWidth
                    slotProps={{
                        paper: {
                            style: {
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                            },
                        }
                    }}
            >
                <Grid container justifyContent={"center"} alignItems={"center"} style={{height: "100%", width: "100%"}}>
                    <img style={{height: "50%", width: "50%", objectFit: "contain"}}
                         src={props.product.Attributes[props.attribute.Name]} alt={props.attribute.Name}/>
                </Grid>

                <IconButton
                    style={{position: "fixed", top: "20px", right: "20px", color: "gray", background: "#F5F5F5"}}
                    onClick={() => setImageEnlarge(false)}
                    size="large">
                    <CloseIcon/>
                </IconButton>
            </Dialog>
        </Grid>
    );
}
